export default __webpack_public_path__ + "static/media/no.3f38176c.svg";